import { useCallback, useEffect, useMemo, useState } from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import Context from "./Context";
import axios from "../components/axios/axios";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";

const socket = io("https://api.alfaleiloessistema.com", {
  transports: ["websocket"],
  withCredentials: true,
});

export default function Provider({ children }) {

  useEffect(() => {
    // Conecte o socket apenas uma vez
    if (!socket.connected) {
      socket.connect();
      console.log('Socket Conectado')
    }

    // Cleanup: Desconecte o socket ao desmontar o Provider
    return () => {
      console.log("🧹 Desconectando o socket no Provider");
      socket.disconnect();
    };
  }, []);

  // const [notificacoes, setNotificacoes] = useState([]);
  const [isShowing, setIsShowing] = useState(false);
  const [atividadeRecebida, setAtividadeRecebida] = useState(null);
  const [atividades, setAtividades] = useState([])
  const [solicitacaoAndamentoId, setSolicitacaoAndamentoId] = useState(null);
  const nav = useNavigate();

  const show = () => {
    setIsShowing(true);
    setTimeout(() => {
      setIsShowing(false);
    }, [4000]);
  };

  // const pushAtv = useCallback((atv) => {
  //   if(atv) {
  //     setAtividades([atv, ...atividades])
  //   }
  // }, [atividades])

  useEffect(() => {
    socket.on("atividade", (data) => {

      if (data.usuario_id == usuario.id || data.solicitante_id == usuario.id) {
        setAtividades((prev) => {
          return [data, ...prev]
        })
        if (data.solicitante_id &&  data.solicitante_id != usuario.id) {
          show()
          setAtividadeRecebida(data)
        }
      }
      return () => {
        socket.off("atividade");
      };
    });
  }, []);

  useEffect(() => {
    console.log('effect', atividades)
  }, [atividades])

  const [usuario, setUsuario] = useLocalStorage("usuario", null);
  const [captacaoGeral, setCaptacaoGeral] = useState([]);
  const [indicacao, setIndicacao] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [repetentes, setRepetentes] = useState({})
  const [dadosCalculo, setDadosCalculo] = useState({})


  const fetchData = async () => {
    try {
      setIsLoading(true);
      const captacaoResponse = await axios.get("/captacao");
      const indicacaoResponse = await axios.get("/indicacao");
      setCaptacaoGeral(captacaoResponse.data);
      setIndicacao(indicacaoResponse.data);
      setIsLoading(false);
    } catch (error) { }
  };
  useEffect(() => {
    fetchData();
  }, []);

  function getDarkColor() {
    const hue = Math.floor(Math.random() * 360); // 0–359
    const saturation = Math.floor(Math.random() * 30) + 70; // 70–100%
    const lightness = Math.floor(Math.random() * 20) + 20; // 20–40% → garante cor escura

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }


  const value = useMemo(
    () => ({
      usuario,
      setUsuario,
      captacaoGeral,
      setCaptacaoGeral,
      indicacao,
      setIndicacao,
      isLoading,
      setIsLoading,
      socket,
      // notificacoes,
      // setNotificacoes,
      solicitacaoAndamentoId,
      setSolicitacaoAndamentoId,
      atividades,
      setAtividades
    }),
    [
      usuario,
      captacaoGeral,
      indicacao,
      isLoading,
      solicitacaoAndamentoId,
      setSolicitacaoAndamentoId,
      atividades,
      setAtividades
    ],
  );
  return (
    <Context.Provider value={value}>
      <div className="relative">
        {isShowing && (
          <div
            style={{ backgroundColor: getDarkColor() }}
            onClick={() => nav("/home")}
            className={`absolute cursor-pointer top-5 right-5 z-50 bg-gradient-to-br text-white shadow-lg rounded-xl p-4 w-72 animate-fade-in-down backdrop-blur-md`}
          >
            <p className="first-letter:capitalize text-base font-medium">
              Nova Atividade: {atividadeRecebida?.atividade?.slice(0, 25)}...
            </p>
            <p className="text-sm text-blue-100 italic">
              De: {atividadeRecebida?.solicitante?.nome}
            </p>
          </div>
        )}
        {children}
      </div>
    </Context.Provider>
  );
}